"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const useFormValidationState = require("../../../../chunks/useFormValidationState-DUZahEdK.js");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
const foundations_typography_Text_Text = require("../../../../foundations/typography/Text/Text.js");
const components_input_elements_unstyled_RadioBase_hooks_useRadioContext = require("../unstyled/RadioBase/hooks/useRadioContext.js");
const helpers_module = require("../../../../chunks/helpers.module-CyAR4a3K.js");
const utils = require("../../../../chunks/utils-DLbQ3blk.js");
const mergeProps = require("../../../../chunks/mergeProps-AWQ5Mc81.js");
const utils$1 = require("../../../../chunks/utils-8c_2IZTy.js");
const filterDOMProps = require("../../../../chunks/filterDOMProps-DSqQIo6b.js");
const FocusScope = require("../../../../chunks/FocusScope-0GplIN9n.js");
const useFocusWithin = require("../../../../chunks/useFocusWithin-DJC0ie9P.js");
const useField = require("../../../../chunks/useField-1Oa9bSpn.js");
const context = require("../../../../chunks/context-0imoXLmo.js");
function $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state) {
  let { name, form, isReadOnly, isRequired, isDisabled, orientation = "vertical", validationBehavior = "aria" } = props;
  let { direction } = context.$18f2051aff69b9bf$export$43bb16f9c6d9e3f7();
  let { isInvalid, validationErrors, validationDetails } = state.displayValidation;
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = useField.$2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: state.isInvalid,
    errorMessage: props.errorMessage || validationErrors
  });
  let domProps = filterDOMProps.$65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let { focusWithinProps } = useFocusWithin.$9ab94262bd0047c7$export$420e68273165f4ec({
    onBlurWithin(e) {
      var _props_onBlur;
      (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 ? void 0 : _props_onBlur.call(props, e);
      if (!state.selectedValue) state.setLastFocusedValue(null);
    },
    onFocusWithin: props.onFocus,
    onFocusWithinChange: props.onFocusChange
  });
  let onKeyDown = (e) => {
    let nextDir;
    switch (e.key) {
      case "ArrowRight":
        if (direction === "rtl" && orientation !== "vertical") nextDir = "prev";
        else nextDir = "next";
        break;
      case "ArrowLeft":
        if (direction === "rtl" && orientation !== "vertical") nextDir = "next";
        else nextDir = "prev";
        break;
      case "ArrowDown":
        nextDir = "next";
        break;
      case "ArrowUp":
        nextDir = "prev";
        break;
      default:
        return;
    }
    e.preventDefault();
    let walker = FocusScope.$9bf71ea28793e738$export$2d6ec8fc375ceafa(e.currentTarget, {
      from: e.target,
      accept: (node) => node instanceof utils$1.$431fbd86ca7dc216$export$f21a1ffae260145a(node).HTMLInputElement && node.type === "radio"
    });
    let nextElem;
    if (nextDir === "next") {
      nextElem = walker.nextNode();
      if (!nextElem) {
        walker.currentNode = e.currentTarget;
        nextElem = walker.firstChild();
      }
    } else {
      nextElem = walker.previousNode();
      if (!nextElem) {
        walker.currentNode = e.currentTarget;
        nextElem = walker.lastChild();
      }
    }
    if (nextElem) {
      nextElem.focus();
      state.setSelectedValue(nextElem.value);
    }
  };
  let groupName = mergeProps.$bdb11010cef70236$export$f680877a34711e37(name);
  utils.$884aeceb3d67f00f$export$37b65e5b5444d35c.set(state, {
    name: groupName,
    form,
    descriptionId: descriptionProps.id,
    errorMessageId: errorMessageProps.id,
    validationBehavior
  });
  return {
    radioGroupProps: mergeProps.$3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown,
      "aria-invalid": state.isInvalid || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-readonly": isReadOnly || void 0,
      "aria-required": isRequired || void 0,
      "aria-disabled": isDisabled || void 0,
      "aria-orientation": orientation,
      ...fieldProps,
      ...focusWithinProps
    }),
    labelProps,
    descriptionProps,
    errorMessageProps,
    isInvalid,
    validationErrors,
    validationDetails
  };
}
let $a54cdc5c1942b639$var$instance = Math.round(Math.random() * 1e10);
let $a54cdc5c1942b639$var$i = 0;
function $a54cdc5c1942b639$export$bca9d026f8e704eb(props) {
  let name = React.useMemo(() => props.name || `radio-group-${$a54cdc5c1942b639$var$instance}-${++$a54cdc5c1942b639$var$i}`, [
    props.name
  ]);
  var _props_defaultValue;
  let [selectedValue, setSelected] = useFormValidationState.$458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange);
  let [initialValue] = React.useState(selectedValue);
  let [lastFocusedValue, setLastFocusedValue] = React.useState(null);
  let validation = useFormValidationState.$e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value: selectedValue
  });
  let setSelectedValue = (value) => {
    if (!props.isReadOnly && !props.isDisabled) {
      setSelected(value);
      validation.commitValidation();
    }
  };
  let isInvalid = validation.displayValidation.isInvalid;
  var _props_defaultValue1;
  return {
    ...validation,
    name,
    selectedValue,
    defaultSelectedValue: props.value !== void 0 ? initialValue : (_props_defaultValue1 = props.defaultValue) !== null && _props_defaultValue1 !== void 0 ? _props_defaultValue1 : null,
    setSelectedValue,
    lastFocusedValue,
    setLastFocusedValue,
    isDisabled: props.isDisabled || false,
    isReadOnly: props.isReadOnly || false,
    isRequired: props.isRequired || false,
    validationState: props.validationState || (isInvalid ? "invalid" : null),
    isInvalid
  };
}
const RadioGroup = React.forwardRef(
  ({
    children,
    style,
    className,
    showLabel = true,
    labelVariant = "text-body-head",
    labelComponent = "h3",
    labelClassName,
    ...props
  }, ref) => {
    const state = $a54cdc5c1942b639$export$bca9d026f8e704eb(props);
    const { radioGroupProps, labelProps } = $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state);
    return /* @__PURE__ */ jsxRuntime.jsxs("div", { ...radioGroupProps, ref, style, className, children: [
      /* @__PURE__ */ jsxRuntime.jsx(
        foundations_typography_Text_Text.Text,
        {
          ...labelProps,
          className: clsx.clsx(labelProps.className, !showLabel && helpers_module.helpers.srOnly, labelClassName),
          variant: labelVariant,
          component: labelComponent,
          children: props.label
        }
      ),
      /* @__PURE__ */ jsxRuntime.jsx(
        components_input_elements_unstyled_RadioBase_hooks_useRadioContext.RadioContext.Provider,
        {
          value: {
            state
          },
          children
        }
      )
    ] });
  }
);
exports.RadioGroup = RadioGroup;
